import React from "react";
import { Helmet } from "react-helmet";
import "../css/TermsConditions.css";

const TermsConditions = () => {
  return (
    <div>
      <Helmet>
        <title>Terms & Conditions | Sanavi Travels</title>
        <meta
          name="description"
          content="Terms & Conditions of Sanavi Travels cab and travel services."
        />
      </Helmet>

      {/* Page Header */}
      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  Terms & Conditions
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <section className="terms-section">
        <div className="container">
          <div className="row g-0">
            <div className="col-md-7">
              <div className="terms-content">
                <p>
                  <b className="highlight">1. Booking Confirmation:</b> All
                  bookings with Sanavi Travels are subject to availability and
                  confirmation after payment or team approval.
                </p>

                <p>
                  <b className="highlight">2. Payment:</b> Payments can be made
                  online, via UPI, or in cash to the driver. Advance payment may
                  be required for outstation trips.
                </p>

                <p>
                  <b className="highlight">
                    3. Cancellation & Rescheduling:
                  </b>{" "}
                  Cancellations must follow Sanavi Travels’ cancellation policy.
                  Charges may apply depending on timing.
                </p>

                <p>
                  <b className="highlight">4. Passenger Responsibility:</b>{" "}
                  Customers must provide accurate pickup details and carry valid
                  identification.
                </p>

                <p>
                  <b className="highlight">5. Baggage Policy:</b> Baggage limits
                  depend on the vehicle type. Excess baggage may incur extra
                  charges.
                </p>

                <p>
                  <b className="highlight">6. Travel Insurance:</b> Sanavi
                  Travels does not provide travel insurance. Customers may
                  arrange their own coverage.
                </p>

                <p>
                  <b className="highlight">7. Safety Rules:</b> Seatbelts must be
                  worn at all times. Passengers must follow safety guidelines.
                </p>

                <p>
                  <b className="highlight">8. Trip Modifications:</b> Additional
                  stops, extended hours, or route changes may attract extra
                  charges.
                </p>

                <p>
                  <b className="highlight">9. Right to Refuse Service:</b>{" "}
                  Sanavi Travels reserves the right to refuse service in cases of
                  misconduct or unsafe behavior.
                </p>

                <p>
                  <b className="highlight">10. Jurisdiction:</b> All disputes
                  shall be governed by Indian law.
                </p>

                <h3>General Policy</h3>
                <p>
                  <b className="highlight">Booking Channels:</b> Bookings can be
                  made via phone, website, or WhatsApp.
                </p>
                <p>
                  <b className="highlight">Customer Support:</b> Our support team
                  assists with bookings, corporate travel, and special
                  requirements.
                </p>

                <h3>Refund Policy</h3>
                <p>
                  <b className="highlight">Cancellation Charges:</b> Refund
                  eligibility depends on booking type and cancellation timing.
                </p>
                <p>
                  <b className="highlight">Refund Timeline:</b> Refunds are
                  processed to the original payment method within banking
                  timelines.
                </p>
                <p>
                  <b className="highlight">No-Show Policy:</b> No-shows without
                  prior notice may not be eligible for refunds.
                </p>
              </div>
            </div>
          </div>

          {/* Contact Info */}
          <div className="contact-info">
            <h2>Contact Us</h2>
            <p>For any questions regarding our policies, contact us:</p>
            <ul>
              <li>
                <b>Phone:</b>{" "}
                <a href="tel:+917387507373">+91 7387507373</a>
              </li>
              <li>
                <b>Email:</b>{" "}
                <a href="mailto:bookings@sanavitravels.com">
                  bookings@sanavitravels.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsConditions;
